import layer from './layer'
import stylesContainer from '../containers/styles-container'
import mergeDescriptors from '../../utils/merge-descriptors'

const props = {
  /**
   * When set to `true`, feature batches will be recreated during animations.
   * @type {boolean}
   * @default false
   */
  updateWhileAnimating: Boolean,
  /**
   * When set to `true`, feature batches will be recreated during interactions.
   * @type {boolean}
   * @default false
   */
  updateWhileInteracting: Boolean,
  /**
   * @type {number|undefined}
   */
  renderBuffer: {
    type: Number,
    default: 100,
  },
  /**
   * @type {ol.RenderOrderFunction|undefined}
   */
  renderOrder: Function,
  /**
   * @type {boolean}
   */
  declutter: Boolean,
}

const methods = {
  /**
   * @return {Promise<Vue<ol.layer.Layer>>}
   * @protected
   */
  init () {
    return layer.methods.init.call(this)
  },
  /**
   * @return {void|Promise<void>}
   * @protected
   */
  deinit () {
    return layer.methods.deinit.call(this)
  },
  /**
   * @returns {Object}
   * @protected
   */
  getServices () {
    return mergeDescriptors(
      layer.methods.getServices.call(this),
      stylesContainer.methods.getServices.call(this)
    )
  },
  /**
   * @return {ol.layer.Vector|undefined}
   * @protected
   */
  getStyleTarget () {
    return this.$layer
  },
  /**
   * @return {void}
   * @protected
   */
  mount () {
    // console.log("Mount vector-layer")
    layer.methods.mount.call(this)
  },
  /**
   * @return {void}
   * @protected
   */
  unmount () {
    layer.methods.unmount.call(this)
  },
}

export default {
  mixins: [layer, stylesContainer],
  props,
  methods,
}


// WEBPACK FOOTER //
// ./resources/js/map/MapComponents/mixins/layers/vector-layer.js